export default "__VITE_ASSET__NRtHPKUD__"